import ENDPOINTS from 'api/endpoints';
import { doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type {
  PostBatchTranslationsRequest,
  PostBatchTranslationsResponse,
} from './types';

export const postBatchTranslations = ({
  accountId,
  projectId,
  translatePayload,
}: {
  accountId: string;
  projectId: string;
  translatePayload: PostBatchTranslationsRequest;
}) =>
  doPost<PostBatchTranslationsResponse>(
    generateNextPath(ENDPOINTS.TRANSLATIONS_BATCH, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    translatePayload,
  );
